import { useNavigate } from 'react-router-dom';
import telegramService from '../services/telegram';
import { buildMosaic } from '../utils/categoryMosaic';

const CategoryGrid = ({ categories }) => {
  const navigate = useNavigate();

  const handleCategoryClick = (slug) => {
    telegramService.hapticFeedback('light');
    navigate(`/category/${slug}`);
  };

  // Получить URL изображения категории
  const getImageUrl = (category) => {
    if (category.icon?.data?.url) {
      return category.icon.data.url;
    }
    if (category.icon?.url) {
      return category.icon.url;
    }
    return null;
  };

  const layout = buildMosaic(categories.length);

  return (
    <div className="grid grid-cols-3 gap-2">
      {categories.map((category, index) => {
        const imageUrl = getImageUrl(category);
        const itemStyle = layout[index];

        return (
          <button
            key={category.id}
            onClick={() => handleCategoryClick(category.slug)}
            className="relative overflow-hidden cursor-pointer transition-transform active:scale-95"
            style={{
              ...itemStyle,
              borderRadius: 'var(--radius-xl)',
              backgroundColor: category.color || 'var(--color-bg-secondary)'
            }}
          >
            {/* Иконка в правом верхнем углу */}
            {imageUrl && (
              <div className="absolute top-2.5 right-2.5 w-[40px] h-[40px]">
                <img
                  src={imageUrl}
                  alt={category.name}
                  className="w-full h-full object-contain"
                />
              </div>
            )}

            {/* Текст в левом нижнем углу */}
            <div className="absolute bottom-3 left-3 right-3 text-left">
              {/* Плашка всегда светлая (цвет из Strapi), поэтому подпись
                  тёмная в обеих темах — см. BRANDBOOK.md, раздел 2.9 */}
              <span className="text-body-sm leading-none" style={{ fontWeight: 600, color: '#16181D' }}>
                {category.name}
              </span>
            </div>
          </button>
        );
      })}
    </div>
  );
};

export default CategoryGrid;
